import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { checkAllGrant } from '../utils';
const formToFeaturePermission = require('../common/mappings/page-to-permission');

function mapStateToProps(state) {
  return {
    permissions: state.permissions.ui,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default function asyncComponent(importComponent, pageName) {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null,
        pageName,
      };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();

      this.setState({
        component: component,
      });
    }

    render() {
      const C = this.state.component;

      if (this.state.pageName) {
        let permissionToCheck = formToFeaturePermission(this.state.pageName);
        if (typeof permissionToCheck === 'object') {
          if (window.location.href.includes('/add')) {
            permissionToCheck = permissionToCheck['add'];
          } else if (window.location.href.includes('/edit')) {
            permissionToCheck = permissionToCheck['edit'];
          } else if (window.location.href.includes('/renew')) {
            permissionToCheck = permissionToCheck['edit'];
          }
        }

        if (this.props.permissions && permissionToCheck) {
          const [prefix, feature, grant] = permissionToCheck.split(':');

          const isAllowed = grant !== 'full'
            ? this.props.permissions[permissionToCheck]
            : checkAllGrant(prefix, feature, this.props.permissions);

          if (!isAllowed) {
            return (
              <div>
                <br />
                <div className="ui negative message">
                  <div className="header">
                    <FormattedMessage
                      id="admin.aync_compoment.unauthorized_access"
                      defaultMessage="Unauthorized Access"
                    />
                  </div>
                  <p>
                    <FormattedMessage
                      id="admin.aync_compoment.you_are_not_allowed_to_view_this_page"
                      defaultMessage="You are not allowed to view this page"
                    />
                  </p>
                  <p>
                    <FormattedMessage
                      id="admin.aync_compoment.you_can_go_to_the"
                      defaultMessage="You can go to the"
                    />
                    <a href="/admin" className="ui text">
                      {' '}
                      <strong>
                        <FormattedMessage
                          id="admin.aync_compoment.homepage"
                          defaultMessage="Home Page"
                        />
                      </strong>
                    </a>
                  </p>
                </div>
              </div>
            );
          }
        }
      }

      const isEmbedded = window.location.href.includes('/embedded');

      return C ? <C {...this.props} isEmbedded={isEmbedded} /> : null;
    }
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AsyncComponent);
}
